import { ContentType, PlaylistItem } from '#types/generated/graphql-types';

export type SeriesContext = {
  episodes: PlaylistItem[];
};

export type State = {
  contentType?: ContentType;
  visible: boolean;
  canShowPlayer: boolean;
  mediaIri?: string;
  series?: SeriesContext;
  onNextEpisode?: () => void;
};

export const state: State = {
  visible: false,
  canShowPlayer: true, // Default to true so it can be used
};
